export enum ROUTES {
  HOME='/',
  CONTACT='/contact',
  ABOUT='/about',
  THE_MORSE_CODE="/blog/the-morse-code",
  SAMUEL_MORSE="/blog/samuel-morse",
  THE_TELEGRAPH="/blog/the-telegraph",
  PRIVACY_POLICY="/privacy-policy",
  TERMS_CONDITIONS="/terms-and-conditions"
}